import PincodesContainer from "./PincodesContainer";

export default PincodesContainer;
